import { useEffect, useState, useRef } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Onopenmodalsetting } from '../../Redux/Actions/Action';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { fetchProfile } from '../../Redux/Reducers/ProfileReducer';
import astroLogo from '../../assets/images/astro-logo.svg';
import menuData from '../Data/Menu/menu.json';

function Header(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userData = JSON.parse(localStorage.getItem("astroVani-admin-data"));
    const Profile = useSelector((state) => state?.ProfileReducer?.profile);

    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const searchRef = useRef(null);

    useEffect(() => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }
        const query = searchQuery.toLowerCase();
        const results = [];

        const checkMatch = (item) => {
            const matchName = item.name?.toLowerCase().includes(query);
            const matchIdentifier = item.identifier?.toLowerCase().includes(query);
            const matchRouterLink = item.routerLink?.some(link => link.toLowerCase().includes(query));
            return matchName || matchIdentifier || matchRouterLink;
        };

        menuData.menu.forEach(parent => {
            if (parent.children && parent.children.length > 0) {
                parent.children.forEach(child => {
                    if (checkMatch(child)) {
                        results.push({ ...child, pathLabel: `${parent.name} > ${child.name}` });
                    }
                });
            } else {
                if (checkMatch(parent)) {
                    results.push({ ...parent, pathLabel: parent.name });
                }
            }
        });

        setSearchResults(results);
    }, [searchQuery]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setSearchResults([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (location?.pathname === "/profile-pages") {
            dispatch(fetchProfile(userData?._id));
        }
    }, [dispatch]);

    // ✅ Logout handler
    const handleLogout = () => {
        localStorage.removeItem("astroVani-admin-data");
        localStorage.removeItem("astroVani-admin-token");
        window.location.href = process.env.PUBLIC_URL + "/sign-in";
    };

    return (
        <div className="header">
            <nav className="navbar">
                <div className="container-xxl">
                     <Link to="/dashboard">
                    <div><img src={astroLogo} alt="Astro Vani" style={{height: "30px"}} /></div></Link>
                    <div className="d-flex align-items-center ms-auto gap-2">

                        {/* 🔍 Global Sidebar Search */}
                        <div className="position-relative d-none d-md-block me-3" style={{ width: "260px" }} ref={searchRef}>
                            <input 
                                type="text" 
                                className="form-control form-control-sm" 
                                placeholder="Search pages..." 
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onFocus={() => setSearchQuery(searchQuery)}
                                style={{ borderRadius: '20px', paddingLeft: '32px' }}
                            />
                            <i className="icofont-search position-absolute" style={{ top: '9px', left: '12px', color: '#888' }}></i>
                            
                            {/* Search Results Dropdown */}
                            {searchResults.length > 0 && (
                                <div className="position-absolute bg-white shadow rounded mt-1 w-100" style={{ zIndex: 1000, maxHeight: '350px', overflowY: 'auto', border: '1px solid #ddd' }}>
                                    <ul className="list-unstyled mb-0 py-2 text-start">
                                        {searchResults.map((item, index) => (
                                            <li key={index} className="px-3 py-2 border-bottom" style={{ cursor: 'pointer' }} onClick={() => {
                                                navigate(process.env.PUBLIC_URL + "/" + item.routerLink[0]);
                                                setSearchQuery("");
                                                setSearchResults([]);
                                            }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                                                <div className="d-flex align-items-center">
                                                    <i className={`${item.iconClass || 'icofont-page'} me-2`} style={{ color: '#7b1fa2' }}></i>
                                                    <span className="small text-dark fw-bold">{item.name}</span>
                                                </div>
                                                <small className="text-muted d-block mt-1" style={{ fontSize: '11px' }}>{item.pathLabel}</small>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>

                        {/* ⚙️ Settings Button */}
                        <button
                            type="button"
                            className="btn btn-sm btn-light border d-flex align-items-center justify-content-center"
                            style={{ width: "34px", height: "34px" }}
                            onClick={() => props.Onopenmodalsetting(true)}
                        >
                            <i className="icofont-gear-alt fs-6"></i>
                        </button>

                        {/* Signout Button */}
                        <button
                            onClick={handleLogout}
                            className="btn btn-sm btn-primary d-flex align-items-center"
                            style={{ gap: "6px" }}
                        >
                            <i className="icofont-logout fs-6"></i>
                            Sign Out
                        </button>

                    </div>


                    {/* ☰ Sidebar Toggle */}
                    <button
                        className="navbar-toggler p-0 border-0 menu-toggle order-3 ms-2"
                        style={{ width: "34px", height: "34px" }}
                        type="button"
                        onClick={() => {
                            const sidebar = document.getElementById('mainsidemenu');
                            const overlay = document.getElementById('sidebar-overlay');
                            if (sidebar) {
                                sidebar.classList.toggle('open');
                                // Toggle overlay
                                if (overlay) {
                                    if (sidebar.classList.contains('open')) {
                                        overlay.classList.add('active');
                                    } else {
                                        overlay.classList.remove('active');
                                    }
                                }
                            }
                        }}
                    >
                        <span className="fa fa-bars"></span>
                    </button>
                </div>
            </nav>
        </div>
    );
}

const mapStateToProps = ({ Mainreducer }) => ({
    Mainreducer
});

export default connect(mapStateToProps, {
    Onopenmodalsetting
})(Header);
